
(function($) {
	var HeaderView = Backbone.View.extend(_.extend({}, App._base, {
		
		el: '.main-header',

		$logo: null,
		$mainNav: null,

		// Put variables here

		baseHeight: 0,
		headerOffset: .5,

		waypoint: {},
		outSpeed: .3,
		outDistance: 63,
		inSpeed: .6,

		logoOutClass: 'out',
		scrolledClass: 'scroll', 

		// Put functionality here

		OnWayPoint: function(direction) {
			this.SetActiveNav(null);
			if (this.isTablet()) { return; }

			if (direction === 'up') {
				this.ExpandHeader();
			} else {
				this.ShrinkHeader();
			}
		},

			// For header animations
			ShrinkHeader: function(cb) {
				var nY = { y: 0, op: 1 },
					cY = { y: 0 };

				this.$logo.addClass(this.logoOutClass);

				// Animate the translateY of the header container
				TweenMax.to(cY, this.outSpeed, { y: -(this.outDistance), ease: Power2.easeOut,
					onUpdate: this.proxy(function(e) {
						this.$el.css('transform', 'translateY(' +cY.y+ 'px)');
					}),
					onComplete: this.proxy(function() {
						TweenMax.to(nY, this.outSpeed / 2, { y: -(this.outDistance), op: 0, ease: Linear.none,
							onUpdate: this.proxy(function(e) {
								this.$mainNav.css({
									'transform': 'translateY(' +nY.y+ 'px)',
									'opacity': nY.op
								});
							}),
							onComplete: this.proxy(function(e) {
								this._ShrinkHeaderIn();
							})
						});
					})
				});
			},

				_ShrinkHeaderIn: function() {
					this.$el.addClass(this.scrolledClass);

					this.$logo.removeClass(this.logoOutClass);

					this.$mainNav.css({
						'transform': 'translateY(10px)',
						'opacity': 0
					});

					var nY = { y: 10, op: 0 };

					TweenMax.to(nY, this.outSpeed * 2, { y: 0, op: 1, ease: Power2.easeOut,
						onUpdate: this.proxy(function(e) {
							this.$mainNav.css({
								'transform': 'translateY(' +nY.y+ 'px)',
								'opacity': nY.op
							});
						})
					});
				},

			ExpandHeader: function(cb) {
				var nY = { y: 0, op: 1 };

				this.$el.css('transform', 'translateY(0px)');

				TweenMax.to(nY, this.outSpeed / 2, { y: 10, op: 0, ease: Power2.easeOut,
					onUpdate: this.proxy(function(e) {
						this.$logo.css('opacity', nY.op);
						this.$mainNav.css({
							'opacity': nY.op
						});
					}),
					onComplete: this.proxy(function(e) {
						this.$el.removeClass(this.scrolledClass);
						this._ExpandHeaderIn();
					})
				});
			},

				_ExpandHeaderIn: function() {
					var nY = { y: -(this.outDistance), op: 0 };

					TweenMax.to(nY, this.outSpeed, { y: 0, ease: Power2.easeOut,
						onUpdate: this.proxy(function(e) {
							this.$mainNav.css('transform', 'translateY(' +nY.y+ 'px)');
						})
					});
					TweenMax.to(nY, this.outSpeed * 2, { op: 1, ease: Power2.easeIn,
						onUpdate: this.proxy(function(e) {
							this.$logo.css('opacity', nY.op);
							this.$mainNav.css('opacity', nY.op); 
						})
					});
				},

		OnLogoClick: function(e) {
			e.preventDefault();

			App.Events.trigger('navClick');
			App.Events.trigger('homeClick');

			this.SetActiveNav(null);
			window.location.hash = '';

			TweenMax.to(window, .5, { scrollTo: { y: 0 }, ease: Linear.easeInOut,
				onComplete: this.proxy(function() {
					this.removeHash();
					App.Events.trigger('navScrollComplete');
				})
			});
		},

		OnNavItemClick: function(e) {
			var $$ = $(e.currentTarget),
				hash = $$.prop('hash'),
				h = hash.split('/'),
				s = h[1],
				$t = $('#'+s),
				t = $t.offset().top;

			if ($$.hasClass('natural')) {
				return;
			}

			e.preventDefault();

			// Set the item active
			this.SetActiveNav($$);
			window.location.hash = hash;

			App.Events.trigger('navClick');

			if (this.isTablet()) {
				this.$el.removeClass('showing');
				if (s === 'portfolios') {
					t = $('#'+h[2]+'-portfolio').offset().top;
				}
				t -= this.$el.height();
			} else {
				// If this is the about section, we need to compensate for the header
				if (s === 'about') {
					t -= 90; // TODO: Figure out how to make this dynamic
				}
			}

			TweenMax.to(window, .5, { scrollTo: { y: t }, ease: Linear.easeInOut,
				onComplete: this.proxy(function() {
					// Check if this is a portfolio and if there's a subsection.
					if (s === 'portfolios' && !this.isTablet()) {
						var $p = $('#' +h[2]+ '-portfolio'),
							ind = $p.index();
						App.Events.trigger('portfolioRequest', ind);
					}

					//App.Routes.navigate('', false);
					App.Events.trigger('navScrollComplete'); 
				})
			});
		},

			SetActiveNav: function($el) {
				$('a', this.$mainNav).each(function() {
					var $$ = $(this);
					$$.parent().removeClass('current-menu-item');
				});

				if ($el) {
					$el.parent().addClass('current-menu-item');
				}
			},

		OnMenuButtonClick: function(e) {
			e.preventDefault();
			if (this.isTablet()) {
				this.$el.toggleClass('showing');
			}
		},

		OnWindowResize: function(e) {
			clearTimeout(this.resizeDebounce);
			this.resizeDebounce = setTimeout(this.proxy(function() {
				var ww = $(window).width();

				if (this.lastWidth != ww && this.isTablet()) {
					this.$el.removeClass('showing');
					//this.ExpandHeader();
				}

				this.lastWidth = ww;
			}), 250);
		},

		bindEvents: function() {
			$('.brand', this.$el).click(this.proxy(this.OnLogoClick));
			$('a', this.$mainNav).click(this.proxy(this.OnNavItemClick));
			$('.mobile-menu', this.$el).click(this.proxy(this.OnMenuButtonClick));

			this.waypoint = new Waypoint({
				element: $('.video-hero-section'),
				offset: -(this.baseHeight * this.headerOffset),
				handler: this.proxy(this.OnWayPoint)
			});

			$(window).resize(this.proxy(this.OnWindowResize));
		},

		ready: function() {
			this.bindEvents();
		},

		initialize: function(options) {
			App.Events.on('ready', this.proxy(this.ready)); 
			this.baseHeight = this.$el.height();

			this.$logo = $('.brand', this.$el);
			this.$mainNav = $('.main-navigation-container', this.$el);
		}
	}));

	App.Views.Header = new HeaderView();
})(jQuery);  